import { Box, ReassignContactCard, Typography } from '@atgfr8/atg-ui-tailwind';
import { ReassignTypeEnum } from '@common/types';
import { Button, Popover } from '@components';
import { openModal } from '@store/modals';
import { ILoadEditViewModel } from '@typeDefinitions/loadTypes';
import { formatDataTestId } from '@utils/dataTestIdFormatter';
import { ASSIGN_LOAD_ID } from '@views/order/constants';
import { Show } from 'solid-js';

import { loadInfoStore } from './store';
import { handleReassignedUser } from './utils';

type PropsT = {
  load: ILoadEditViewModel;
  tabIndex: number;
};

export const AssignedTo = (props: PropsT) => {
  return (
    <div>
      <div class="flex bg-[#dfecf2] p-2 rounded-sm max-h-12 min-w-52">
        <Box>
          <Popover
            eleName={
              <div class="text-left">
                <div class="text-[#123b50] font-semibold text-xs">
                  Assigned To
                </div>
                <Show
                  when={props.load.assignedToUser != null}
                  fallback={
                    <Typography
                      variant="body1"
                      component="div"
                      sxProps={{ textAlign: 'left' }}
                    >
                      -
                    </Typography>
                  }
                >
                  <div class="font-medium">{props.load.assignedToUser}</div>
                </Show>
              </div>
            }
            onClick={() => {
              void handleReassignedUser(
                props.load.assignedToUserId as number,
                ReassignTypeEnum.AssignedTo,
              );
            }}
            sxProps={{
              'text-transform': 'none',
              padding: '0px',
            }}
            class="[&:hover]:bg-none"
          >
            <Box style={{ padding: '8px' }}>
              <ReassignContactCard
                contact={loadInfoStore.assignedTo}
                showIcon
                isLoading={loadInfoStore.isLoading}
              />
            </Box>
          </Popover>
        </Box>
        <div class="ml-auto mt-3.5">
          <Button
            variant="text"
            class="text-[#026EA1]! font-medium! text-sm! leading-6! tracking-tighter! cursor-pointer! !h-[24px] !min-w-0 !px-1 !py-0"
            label="REASSIGN"
            onClick={() => openModal(`${ASSIGN_LOAD_ID}-${props.tabIndex}`)}
            dataTestId={formatDataTestId('REASSIGN', 'button')}
          />
        </div>
      </div>
      <div class="flex items-center">
        <Show when={props.load.assignedToGroup != null}>
          <div class="opacity-60 text-xs font-medium ml-2 ">
            {props.load.assignedToGroup}
          </div>
        </Show>
        <Show
          when={
            props.load.assignedToGroup != null &&
            props.load.capacityGroupName !== ''
          }
        >
          <div class="opacity-60 text-xs font-medium ml-2 ">-</div>
        </Show>
        <Show when={props.load.capacityGroupName !== ''}>
          <div class="opacity-60 text-xs font-medium ml-2 ">
            {props.load.capacityGroupName}
          </div>
        </Show>
      </div>
    </div>
  );
};
